// DuckPilot warm-paper theme for Clerk components (Design Brief tokens).
// Driven mostly by `variables` so every Clerk surface stays on-brand; a few
// element overrides use plain style objects (no Tailwind dependency inside Clerk).

export const clerkAppearance = {
  variables: {
    colorPrimary: '#c67139', // bill.500 — the single action color
    colorText: '#201e1d', // ink
    colorTextSecondary: '#645c50', // sand-700
    colorTextOnPrimaryBackground: '#ffffff',
    colorBackground: '#ffffff',
    colorInputBackground: '#f9f4ed', // sand-100
    colorInputText: '#201e1d',
    colorNeutral: '#201e1d',
    colorDanger: '#b2622d',
    colorSuccess: '#7a8a5e', // sage
    colorWarning: '#c67139',
    borderRadius: '14px',
    fontFamily: '"Space Grotesk", system-ui, sans-serif',
    fontFamilyButtons: '"Space Grotesk", system-ui, sans-serif',
    fontSize: '14px',
  },
  elements: {
    card: {
      backgroundColor: '#ffffff',
      border: '1px solid rgba(32,30,29,0.12)',
      boxShadow: '0 18px 48px rgba(46,43,37,0.20)',
      borderRadius: '28px',
    },
    // the rounded-square panel Clerk renders behind the card
    rootBox: { fontFamily: '"Space Grotesk", system-ui, sans-serif' },
    headerTitle: {
      fontFamily: '"Caprasimo", Georgia, serif',
      fontWeight: 400,
      letterSpacing: '-0.01em',
      color: '#201e1d',
    },
    headerSubtitle: { color: '#645c50' },
    formButtonPrimary: {
      backgroundColor: '#c67139',
      color: '#ffffff',
      textTransform: 'none',
      fontWeight: 600,
      boxShadow: '0 1px 2px rgba(46,43,37,0.10)',
      '&:hover': { backgroundColor: '#b2622d' },
      '&:focus': { backgroundColor: '#b2622d' },
    },
    formFieldInput: {
      backgroundColor: '#f9f4ed',
      borderColor: 'rgba(32,30,29,0.18)',
      color: '#201e1d',
    },
    socialButtonsBlockButton: {
      borderColor: 'rgba(32,30,29,0.18)',
      backgroundColor: '#ffffff',
    },
    dividerLine: { backgroundColor: 'rgba(32,30,29,0.12)' },
    dividerText: { color: '#82796a' },
    footerActionLink: {
      color: '#8c491a', // bill-700
      fontWeight: 600,
      '&:hover': { color: '#643312' },
    },
    formFieldLabel: { color: '#474238', fontWeight: 600 },
    identityPreviewEditButton: { color: '#8c491a' },
    userButtonPopoverActionButton__signOut: { color: '#8c491a' },
    badge: { backgroundColor: '#f0fae1', color: '#3d472b' },
  },
};

export default clerkAppearance;
